<template>
<v-container>
  <v-form >
    <v-text-field label="Id" v-model="id" readonly></v-text-field>
    <v-text-field label="Codice" v-model="codice" required></v-text-field>
    <v-text-field label="Descrizione" v-model="descrizione" required></v-text-field>
    <v-text-field label="Icona" v-model="icona" required></v-text-field>
    <v-text-field label="Cut String" v-model="cutString" required></v-text-field>
    <v-text-field label="Colore" v-model="colore" required></v-text-field>
    <v-btn large style="margin-left: 0px; box-shadow: none; color: white;" color="#4EABDD" @click="submit">Invia</v-btn>
    <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" @click="clear">Pulisci</v-btn>
  </v-form>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    id: "",
    codice: "",
    descrizione: "",
    cutString: "",
    icona: "",
    colore: "",
    update: false
  }),
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
   mounted() {
    this.CheckJWT();
    this.id = this.$route.params.id;
    if (this.id !== 0 && this.id !== "0") {
      this.getDataForId();
      this.update = true;
    }
   },
  methods: {
    getDataForId() {
      axios
        .get(this.$store.state.servicePath + "/api/ArStatiSpediziones/" + this.id)
        .then(res => {
         this.id = res.data.id;
         this.codice = res.data.codice;
         this.descrizione = res.data.descrizione;
         this.icona = res.data.icona;
         this.cutString = res.data.cutString;
         this.colore = res.data.colore;
        });
    },
    submit() {
      if (this.update) {
        this.UpdateData();
      } else {
        this.InsertData();
      }
    },
    UpdateData() {
      axios
        .put(this.$store.state.servicePath + "/api/ArStatiSpediziones/" + this.id, {
         id: this.id,
         codice: this.codice,
         descrizione: this.descrizione,
         icona: this.icona,
         cutString: this.cutString,
         colore: this.colore
        })
        .then(res => {
          if (res.data.id !== 0) {
            this.$router.go(-1);
          }
        });
    },
    InsertData() {
      axios
        .post(this.$store.state.servicePath + "/api/ArStatiSpediziones/", {
         id: this.id,
         codice: this.codice,
         descrizione: this.descrizione,
         icona: this.icona,
         cutString: this.cutString,
         colore: this.colore
        })
        .then(res => {
          if (res.data.id !== 0) {
            this.$router.go(-1);
          }
        });
    },
    clear() {
        
        this.codice = 0;
        this.descrizione = "";
        this.icona = "";
        this.cutString = "";
        this.colore = "";
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>